var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { ReportManageService } from "~/services/domain-service/report-manage.service";
import { UserService } from "~/services/management-service/user.service";
import SelectDepartment from "~/components/business-component/select-department.vue";
var CollectDaysReport = /** @class */ (function (_super) {
    __extends(CollectDaysReport, _super);
    function CollectDaysReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groupKey = "deptId";
        _this.searchModel = {
            deptId: "",
            collectorId: "",
            deptCode: "",
            queryDate: ''
        };
        _this.dataSet = [];
        _this.userSet = [];
        return _this;
    }
    CollectDaysReport.prototype.refreshData = function () {
        var _this = this;
        this.reportManageService.queryCollectDataDays(this.searchModel)
            .subscribe(function (data) {
            _this.dataSet = data;
            // 因为统计数据插入了新数据，所以需要排序一次
            _this.dataSet.sort(function (a, b) { return a.deptId - b.deptId; });
        });
    };
    CollectDaysReport.prototype.departemntChange = function (id, code) {
        this.searchModel.deptCode = code;
        this.searchModel.userId = '';
        if (!code) {
            this.userSet = [];
        }
        else {
            this.getAllUserByDeptCode(code);
        }
    };
    CollectDaysReport.prototype.getAllUserByDeptCode = function (deptCode) {
        var _this = this;
        this.userService.getAllUsersList({ deptCode: deptCode }).subscribe(function (data) { return _this.userSet = data; });
    };
    CollectDaysReport.prototype.handleResetForm = function () {
        this.searchModel.deptCode = '';
    };
    CollectDaysReport.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(ReportManageService)
    ], CollectDaysReport.prototype, "reportManageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], CollectDaysReport.prototype, "userService", void 0);
    CollectDaysReport = __decorate([
        Auth(2102),
        Layout('workspace'),
        Component({
            components: {
                SelectDepartment: SelectDepartment
            }
        })
    ], CollectDaysReport);
    return CollectDaysReport;
}(Vue));
export default CollectDaysReport;
